import firebase from "firebase/compat/app";

import "firebase/compat/firestore";
import {
  getFirestore,
  setDoc,
  doc,
  deleteDoc,
  serverTimestamp,
} from "firebase/firestore";

import {
  getAuth,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  reauthenticateWithCredential,
  sendEmailVerification,
  EmailAuthProvider,
  deleteUser,
  signOut,
} from "firebase/auth";

// Returns: Promise<void>
function writeUserToFirestore(user) {
  const db = getFirestore();
  return setDoc(
    doc(db, "sandbox", user.uid),
    Object.assign(
      {},
      {
        name: user.email,
        vorname: user.email,
        timestamp: serverTimestamp(),
      }
    )
  )
    .then(() => {
      return { code: 1 };
    })
    .catch((e) => {
      console.log("Error in write user to firestore :",e.message," , code = ", e.code )
      return Promise.reject(e);
    });
}

function createAccount(email, password) {
  const TAG = "firebaseAuthPromises - createAccount : ";
  let user;

  return createUserWithEmailAndPassword(getAuth(), email, password)
    .then((credential) => {
      user = credential.user;
      return sendEmailVerification(user); // Promise<void>
    })
    .then(() => {
      return writeUserToFirestore(user); //
    })
    .catch((e) => {
      console.log("Error in create account :",e.message," , code = ", e.code )
      return Promise.reject(e);
    });
}

function deleteAccount(password) {
  const TAG = "firebaseAuthPromises - deleteAccount : ";
  // Save the user object for final deletion in Firestore
  const user = getAuth().currentUser;

  if (user == null) return Promise.reject("No user is signed in");
  console.log("Call to delete ", user.email);
  // Create the credential - note:  not a promise
  // https://firebase.google.com/docs/reference/js/auth.emailauthprovider
  const authCredential = EmailAuthProvider.credential(user.email, password);

  return reauthenticateWithCredential(user, authCredential)
    .then((credential) => {
      return Promise.resolve(credential.user);
    })
    .then((credentialUser) => {
      return deleteDoc(doc(getFirestore(), "sandbox", credentialUser.uid));
    })
    .then((any) => {
      return deleteUser(user); //This returns a void  promise
    })
    .catch((e) => {
      console.log("Error in delete-Account :",e.message," , code = ", e.code )
      return Promise.reject(e);
    });
}

function signIn(email, password) {
  // console.log("Sign in called");
  const auth = getAuth();
  return signInWithEmailAndPassword(auth, email, password)
    .then( (userCredential) => {
      if (userCredential.user.emailVerified) {
        return Promise.resolve({ code: 1 });
      } else {
        console.log("This user has no verified email adress.");
        return Promise.resolve({ code: 0 });
      }
    })
    .catch((e) => {
      console.log("Error in sign-in :",e.message," , code = ", e.code )
      return Promise.reject(e);
    });
}

function sendActivationMail() {
  if (!getAuth().currentUser) return Promise.reject("No user is signed in.");

  return sendEmailVerification(getAuth().currentUser)
    .then( () => {
        Promise.resolve();
    })
    .then( () => {
        return signOut(getAuth());
      })
    .catch((e) => {
      console.log("Error in send Activation Mails :",e.message," , code = ", e.code )
      return Promise.reject(e);
    });
}

// https://firebase.google.com/docs/reference/js/firebase.auth.Auth#sendPasswordResetEmail
async function sendPasswordResetEmail(email) {
  try {
    await firebase.auth().sendPasswordResetEmail(email);
    return { code: 1 };
  } catch (e) {
    console.log("Error " + e.code);
    if (e.code == "auth/user-not-found") return { code: -1 };
    if (e.code == "auth/network-request-failed") return { code: -2 };
    return { code: -9 };
  }
}

export {
  createAccount,
  deleteAccount,
  sendActivationMail,
  signIn,
  sendPasswordResetEmail,
  writeUserToFirestore, // Just to test it, mnormally only needed internally...
};
